// For AirBrake source maps:
//# sourceMappingURL=main.js.map
import axios from 'axios'
import { ApolloProvider } from '@apollo/react-hooks'
import i18n from 'i18next'
import React from 'react'
import { AccountPage } from './components/AccountPage'
import { AddDevicePage } from './components/AddDevicePage'
import { App } from './components/App'
import { BannerNotices } from './components/BannerNotices'
import { ConfirmationAlert } from './components/ConfirmationAlert'
import { ContactSelector } from './components/ContactSelector'
import { ContactsPage } from './components/ContactsPage'
import { DeviceDetailsModal } from './components/DeviceDetailsModal'
import { DeviceShareContainer } from './components/DeviceShareDialog'
import { DevicesPage } from './components/DevicesPage'
import { DeviceTransferWarning } from './components/DeviceTransferWarning'
import { SplashScreen } from './components/SplashScreen'
// import { NonCommercialBanner } from './components/NonCommercialBanner'
import { EventLogsPage } from './components/EventLogsPage'
import { ProductsPage } from './components/ProductsPage'
import { RegistrationsPage } from './components/RegistrationsPage'
import { ScriptingPage } from './components/ScriptingPage'
import { ServiceConnectionModal } from './components/ServiceConnectionModal'
import { SidebarMenu } from './components/SidebarMenu'
import { RemoveSharingDialog } from './components/RemoveSharingDialog'
import { DeprecationDialog } from './components/DeprecationDialog'
import './i18n'
import renderQuickConnectButtons from './legacy/renderQuickConnectButtons'
import getPlatformCode from './legacy/getPlatformCode'
import renderShareIcon from './legacy/renderShareIcon'
import renderDeleteIcon from './legacy/renderDeleteIcon'
import deviceSearch from './legacy/device-list'
import routes from './routes'
import tracker from './services/Analytics'
import { client } from './services/apolloClient'
import { httpRedirect } from './services/httpRedirect'
import { r3 } from './services/remote.it'
import Router from './services/Router'
import { store } from './store'
import './styles/global.css'
import { determineSidebarCollapseState } from './utils/determineSidebarCollapseState'
import { renderComponents } from './utils/render'

// Hub.listen('auth', data => {
//   // const { payload } = data;
//   console.log(
//     'A new auth event has happened: ',
//     data.payload.data?.username + ' has ' + data.payload.event
//   )
//   console.log('Data:')
//   console.log(data)
//   console.log('Payload:')
//   console.log(data.payload)
// })

// const { auth } = store.dispatch
// auth.init(undefined)

// Make sure user is HTTPS when on production
if (process.env.HTTPS_REDIRECT) httpRedirect()

// Determine if we show/hide the sidebar based on window size.
determineSidebarCollapseState()

if (!i18n.language && navigator && navigator.language) {
  i18n.changeLanguage(
    navigator.language.substr(0, 2) === 'ja' ? navigator.language : 'en-US'
  )
} else {
  i18n.changeLanguage('en-US')
}

const components = {
  '#deprecation-dialog': <DeprecationDialog />,
  '#auth-app': <App />,
  '#notices': <BannerNotices />,
  // '#non-commercial-banner-placeholder': <NonCommercialBanner />,
  '#add-device': <AddDevicePage />,
  '#sidebar-menu-placeholder': <SidebarMenu />,
  '#device-page-placeholder': <DevicesPage />,
  '#scripting-page-placeholder': <ScriptingPage />,
  '#contacts-page-placeholder': <ContactsPage />,
  '#registrations-page-placeholder': <RegistrationsPage />,
  '#products-page-placeholder': <ProductsPage />,
  '#activity-logs-page-placeholder': (
    <ApolloProvider client={client}>
      <EventLogsPage />
    </ApolloProvider>
  ),
  '#account-placeholder': (
    <ApolloProvider client={client}>
      <AccountPage />
    </ApolloProvider>
  ),
  '#sharing-contact-picker': (
    <ContactSelector isMultiSelect={true} selectorType="add-share" />
  ),
  '#transfer-contact-picker': (
    <ContactSelector isMultiSelect={false} selectorType="transfer-device" />
  ),
  '#bulk-reg-contact-picker': (
    <ContactSelector isMultiSelect={false} selectorType="transfer-bulk" />
  ),
  '#device-share-details': <DeviceShareContainer />,
  '#transfer-warning': <DeviceTransferWarning />,
  '#transfer-confirmation': <ConfirmationAlert />,
  '#device-details-modal': <DeviceDetailsModal />,
  '#vnc-service-connection-modal': <ServiceConnectionModal />,
  '#unshare-modal-placeholder': <RemoveSharingDialog />,
  '#splash-page-placeholder': <SplashScreen />,
}

renderComponents(components)

window.remot3it = {
  router: {
    /**
     * Load the hash state change router and set the
     * device list as the default fallback route.
     */
    initialize: () => new Router(routes, '#devices', window),
  },
  store,
  r3,
  helpers: {
    axios,
    deviceSearch,
    renderShareIcon,
    renderDeleteIcon,
    renderQuickConnectButtons,
    track: tracker.track,
    parseServiceType: r3.devices.parseServiceType,
    getPlatformCode,
  },
}
